export enum JmMode {
  JOURNEY_MANAGEMENT = 0,
  NEXT_ACTION = 1,
}

export enum JourneyType {
  PROMOTION = 0,
  ACTIVE = 1,
  GRACEFUL = 2,
}

export enum JourneyButtonType {
  SIMPLE = 0,
  MULTI = 1,
  INFO = 2,
}
export enum JourneyManagerActions {
  CREDIT_INSTALLMENT = 'CREDIT_INSTALLMENT',
  CREDIT_REGISTRATION = 'CREDIT_REGISTRATION',
  CREDIT_PURCHASE = 'CREDIT_PURCHASE',
  RETRY = 'RETRY',
  DISMISS = 'DISMISS',
  REDIRECT = 'REDIRECT',
}
